import { QBankStructureLevelTag } from '@exam-management/components';
import { QBankStructureLevelCategory } from '@exam-management/graphql';
import { Flex, Text, Chip, Divider, EllipsisText } from '@shared/components';
import { formatDateTime } from '@shared/utils';

interface LOSInfoSectionProps {
  name: string;
  qSource: string;
  createdAt?: Date | null;
  updatedAt?: Date | null;
}

export default function LOSInfoSection(props: Readonly<LOSInfoSectionProps>) {
  const { name, qSource, createdAt = null, updatedAt = null } = props;

  const shouldDisplayDates = !!createdAt || !!updatedAt;

  return (
    <Flex
      sx={(theme) => ({
        border: `1px solid ${theme.palette.grey[200]}`,
        flexDirection: 'column',
        p: theme.spacing(4),
        borderRadius: theme.shape.rounded(2),
        backgroundColor: theme.palette.grey[50],
        gap: theme.spacing(4),
      })}
    >
      <Flex sx={{ width: '100%' }}>
        <Flex
          sx={(theme) => ({
            gap: theme.spacing(2),
            width: '100%',
            alignItems: 'center',
          })}
        >
          <QBankStructureLevelTag category={QBankStructureLevelCategory.Chapter} />
          <Divider orientation='vertical' variant='middle' flexItem />
          <EllipsisText variant='body1Semibold' sx={{ flex: 1 }}>
            {name}
          </EllipsisText>
        </Flex>
        <Chip
          label={`QSource: ${qSource}`}
          size='small'
          sx={(theme) => ({
            border: `1px solid ${theme.palette.grey[300]}`,
            backgroundColor: theme.palette.grey[200],
          })}
        />
      </Flex>
      {shouldDisplayDates ? (
        <>
          <Divider />
          <Flex sx={(theme) => ({ width: '100%', gap: theme.spacing(4) })}>
            <Flex sx={(theme) => ({ gap: theme.spacing(2) })}>
              <Text variant='body2'>สร้างเมื่อวันที่:</Text>
              <Text variant='body2Semibold'>{formatDateTime(createdAt)}</Text>
            </Flex>
            <Divider flexItem orientation='vertical' />
            <Flex sx={(theme) => ({ gap: theme.spacing(2) })}>
              <Text variant='body2'>วันที่แก้ไขล่าสุด:</Text>
              <Text variant='body2Semibold'>{formatDateTime(updatedAt)}</Text>
            </Flex>
          </Flex>
        </>
      ) : null}
    </Flex>
  );
}
